import { useTheme } from '@mui/material';
import { BuildOutlined } from '@mui/icons-material';
import Box from '@/components/ui/Box/Box';
import Card from '@/components/ui/Card/Card';
import Typography from '@/components/ui/Typography/Typography';
import type { RepairerCardProps } from './IRepairerCard';
import { styles } from './styles';

const locationsLine = (repairer: RepairerCardProps['repairer']): string => {
    const locs = repairer.locations ?? [];
    if (locs.length > 1) return `${locs.length} Locations`;
    return locs.map((l) => l.nickname ?? l.name ?? '').filter(Boolean).join(', ');
};

const RepairerCard = ({ repairer, isActive, onClick }: RepairerCardProps) => {
    const theme = useTheme();
    const isPendingInvite = Boolean(
        repairer.registration_code || repairer.registrationCode,
    );
    const title = repairer.name?.trim() || repairer.email || 'Pending Invite';
    const services = (repairer.services ?? []).join(', ');
    const locations = locationsLine(repairer);

    return (
        <Card sx={styles.card(isActive)} onClick={() => onClick(repairer.id)}>
            <Box sx={styles.iconBadge(isActive, theme)}>
                <BuildOutlined />
            </Box>
            <Box sx={styles.body}>
                <Typography sx={styles.name}>{title}</Typography>
                {services && <Typography sx={styles.services}>{services}</Typography>}
                {locations && <Typography sx={styles.locations}>{locations}</Typography>}
                {isPendingInvite && (
                    <Typography component="span" sx={styles.pending(theme)}>
                        Pending Invite
                    </Typography>
                )}
            </Box>
        </Card>
    );
};

export default RepairerCard;
